import React from 'react'
import { useFormikContext } from 'formik'
import { AccompanyingReportA1 } from '../generic/AccompanyingReportA1'
import { AccompanyingReportA2 } from '../generic/AccompanyingReportA2'
import { BuildingPermitAccompanyingReportA3 } from './BuildingPermitAccompanyingReportA3'
import { BuildingPermitAccompanyingReportA4 } from './BuildingPermitAccompanyingReportA4'
import { ACCOMPANYING_REPORT_FORM_INITIAL_DATA } from '../../constants'

interface Props {}

export const BuildingPermitAccompanyingReportFields: React.FC<Props> = (props) => {
  const formik = useFormikContext<typeof ACCOMPANYING_REPORT_FORM_INITIAL_DATA>()

  return (
    <>
      <AccompanyingReportA1 formik={formik} withA1C={true} />
      <AccompanyingReportA2 formik={formik} />
      <BuildingPermitAccompanyingReportA3 formik={formik} />
      <BuildingPermitAccompanyingReportA4 formik={formik} />
    </>
  )
}
